import React, {Component} from "react";
import {observer} from "mobx-react";
import DataTable from "react-data-table-component";
import styled from 'styled-components';
import {CalendarStats} from "../AdherenceStats/CalendarStats";
import {AdherenceChart} from "../AdherenceStats/AdherenceChart";
import {OverallSummary} from "../AdherenceStats/OverallSummary";
import patient from "../../stores/patient";
import request from "../../utils/request";
import {customStyles} from "../AdherenceDashboard";

const ComponentContainer = styled.div`
  margin-bottom: 40px;
`;

@observer
export default class AdherencePage extends Component {

  patientID = patient.fields._id;

  constructor(props) {
    super(props)
    this.state = {
      patient: {},
    }
  }

  componentDidMount() {
    this.fetchPatient(this.patientID).then();
  }

  fetchPatient = async (patientID) => {
    const res = await request('/api/adherenceDashboard/getPatientByID', {
      patientID,
    })
    if (res.success) {
      this.setState({patient: res.data.patient})
    }
  }


  getColumns = () => [
    {
      name: 'Monitor ID',
      selector: row => row.monitorID,
      sortable: true,
    },
    {
      name: 'Battery Level',
      selector: row => row.batteryLevel,
      cell: (row) => (
        <div
          style={{
            backgroundColor: row.batteryLevel === 'High' ? 'green' :
              row.batteryLevel === 'Med'? 'Yellow': 'Red',
            color: row.batteryLevel === 'Med'? 'black': 'white',
            padding: '5px',
            borderRadius: '4px',
            textAlign: 'center',
            width: '80px'
          }}
        >
          {row.batteryLevel}
        </div>
      ),
      sortable: false,
    },
    {
      name: 'Prescription',
      selector: row => row.prescription,
    },
    {
      name: 'Last 5 Doses',
      selector: row => row.lastFiveDoses,
      cell: row => (
        <div style={{display: 'flex', justifyContent: 'space-around', minWidth: '100px'}}>
          {row.lastFiveDoses.map((dose, index) => (
            <span key={index} className={`fas ${dose ? 'fa-check' : 'fa-times'}`}
                  style={{color: dose ? 'green' : 'red'}}>
          </span>
          ))}
        </div>
      ),
      sortable: false,
    },
  ];

  render() {
    return (
      <React.Fragment>
        <ComponentContainer>
          <DataTable
            columns={this.getColumns()}
            data={this.state.patient.medications}
            customStyles={customStyles}
          />
        </ComponentContainer>
        <ComponentContainer>
          <CalendarStats />
        </ComponentContainer>
        <ComponentContainer>
          <AdherenceChart />
        </ComponentContainer>
        <ComponentContainer>
          <OverallSummary />
        </ComponentContainer>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PatientSession/AdherencePage.jsx